import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * The home-routers pages require an authenticated user: either someone signed
 * in on the web (token stored in `tygo_user`) or a user deep-linked from the
 * app with `?token=<jwt>` (which `UrlSession` in App.tsx persists into
 * `tygo_user` and then strips from the URL). We accept the token from either
 * place — the URL check covers the brief window before `UrlSession` has saved
 * it — and send the user to sign in (/login2) when there is none. /login2
 * honours a `redirect` query param, so after signing in the user comes back
 * to the page they originally asked for.
 */
const useRequireToken = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("tygo_user") || "{}");
    const urlToken = new URLSearchParams(search).get("token");
    if (!user.token && !urlToken) {
      navigate(`/login2?redirect=${encodeURIComponent(pathname)}`, {
        replace: true,
      });
    }
  }, [search]);
};

export default useRequireToken;
